// @flow
// @jsx h
declare var GOOGLE_API_KEY: string;

import { h } from "preact";

import {APIProvider, Map, Marker, InfoWindow, useMarkerRef } from '@vis.gl/react-google-maps';

import { Text } from "preact-i18n";

const GettingStartedExample = (props) => {
  const [markerRef, marker] = useMarkerRef();
  return (
    <div style={{ height: `100%` }}>
      <APIProvider apiKey={GOOGLE_API_KEY}>
        <Map
          style={{width: '100%', height: '300px'}}
          defaultZoom={13}
          defaultCenter={{
            lat: props.marker.position.lat,
            lng: props.marker.position.lng
          }}
          gestureHandling={'greedy'}
          disableDefaultUI={true}
        >
          <InfoWindow
          anchor={marker}
          >
            <div>
                <h2>
                  <Text id="product.map.itinerary.title">Itinéraire</Text>
                </h2>
                <p>
                  <Text id="product.map.itinerary.link">
                    Pour connaitre l itinéraire :
                  </Text>
                  <a
                    href={`https://www.google.fr/maps/dir/${
                      props.marker.position.lat
                    }, ${props.marker.position.lng}/${props.marker.position.lat},${
                      props.marker.position.lng
                    }/`}
                    target="_blank"
                  >
                    <Text id="product.map.itinerary.clickHere">cliquez-ici</Text>
                  </a>
                  <p>
                    <Text
                      id="product.map.itinerary.coordinates"
                      fields={{
                        lat: props.marker.position.lat,
                        lng: props.marker.position.lng
                      }}
                    >
                      Coordonnées GPS : {props.marker.position.lat.toString()},{" "}
                      {props.marker.position.lng}.
                    </Text>
                  </p>
                </p>
              </div>
          </InfoWindow>
          <Marker
          ref={markerRef}
          position={{
            lat: props.marker.position.lat,
            lng: props.marker.position.lng
          }} >
          </Marker>
        </Map>
      </APIProvider>
    </div>
  );
}

export default GettingStartedExample;
